<template>
  <div class="ux-ugc-wrap">
    <div class="data-panel ugc-panel">
      <ue :pd="ues.pd" :content="ues.content" v-if="$service.PROJ_CODE==='l28' || $service.PROJ_CODE==='demo'"></ue>
      <div class="data-panel-header" style="height: auto;">
        <h2 style="display: flex; justify-content: space-between">
        <div class="ugc-data-panel-stat-box" >
          <!-- <div class="ugc-data-panel-stat" v-if="filterDatas.length!=sortedDatas.length">
            <h3>总玩法数</h3>
            <div class="ugc-data-panel-stat-inner">
              <div class="ugc-data-panel-stat-item">
                <label>总玩法数</label>
                <span>{{ sortedDatas.length }}</span>
              </div>
              <div class="ugc-data-panel-stat-item">
                <label>过滤玩法数</label>
                <span>{{ filterDatas.length }}</span>
              </div>
            </div>
          </div> -->
          <div class="ugc-data-panel-stat">
            <h3>玩法总量</h3>
            <div class="ugc-data-panel-stat-inner">
              <div class="ugc-data-panel-stat-item ugc-data-panel-stat-single-item">
                <label>总量(PGC+UGC)</label>
                <span>{{ meta.sum.real_sum - meta.sum.pause_sum }}</span>
              </div>
              <div class="ugc-data-panel-stat-item ugc-data-panel-stat-single-item">
                <label>总量(PGC)</label>
                <span>{{ meta.sum.real_sum - meta.sum.pause_sum - summary[5] }}</span>
              </div>
            </div>
          </div>
          <div class="ugc-data-panel-stat lab">
            <h3>具体阶段</h3>
            <div class="ugc-data-panel-stat-inner">
              <div class="ugc-data-panel-stat-item">
                <label>{{stageNames[0]}}</label>
                <span>{{ meta.sum.real_sum - stages.length - meta.sum.pause_sum + summary[6] + summary[0] }}</span>
              </div>
              <div :class="`ugc-data-panel-stat-item ugc-data-panel-stat-item-filter ${stageFilter===index+(index===5?2:1)?'ugc-data-panel-stat-item-selected':''}`" v-for="(stageName, index) in stageNames.slice(1).filter(x => x!=='暂停')" :key="stageName" @click="onStageFilter(index + (index===5?2:1))" title="点击筛选">
                <label>{{stageName}}</label>
                <span>{{  summary[index + (index===5?2:1)] }}</span>
              </div>
            </div>
            <div :class="`ugc-data-panel-stat-clear ${stageFilter===undefined?'ugc-data-panel-stat-clear-hidden':''}`" @click="clearStageFilter()" title="清除筛选">×</div>
          </div>
          <!-- <div class="ugc-data-panel-stat inner">
            <h3>内部测试</h3>
            <div class="ugc-data-panel-stat-inner">
              <div class="ugc-data-panel-stat-item">
                <label>玩法数</label>
                <span>{{ summary.inner_cnt }}</span>
              </div>
            </div>
          </div> -->
        </div> 
          <span :style="{float:'right', fontSize: '13px', color: '#666', fontWeight: 'normal'}">表头带下划线的单元格可以点击展开查看详情</span>    
        </h2>    
      </div>      
      <div class="data-panel-content">
        <div className='table-container' id="ux-ugc-table">
          <table class="custom-ugc-gameplay-table" id="ux-ugc-table-thead">
            <thead>
              <tr class="custom-ugc-gameplay-table-tr">
                <template v-for="column in columns">
                  <th  rowspan="2" :key="column.id" v-if="!column.inner && !column.lab" :style="{'width': column.width, 'textDecoration': column.expandable?'underline':'none'}" :class="column.sorter?'sortable':''">
                    <div @click="onChangeSorter(column.id)">
                      <span>{{column.title}}</span>
                      <span :class="`sorter-icon ${sorter.id===column.id?`sorter-${sorter.order}`:''}`" v-if="column.sorter">
                        <a-icon type="caret-up" />
                        <a-icon type="caret-down" />
                      </span>
                      <a-popover placement="bottom" overlayClassName="ugc-table-filter-container"  v-if="column.filter">
                        <template slot="content">
                          <div class="ugc-table-filter-box">
                            <p><a-input placeholder="搜索" v-model="filterOptionFilters[column.id]"/></p>
                            <p v-for="v in filterOptions[column.id]" :key="v" v-show="!filterOptionFilters[column.id] || v.toLowerCase().indexOf(filterOptionFilters[column.id].toLowerCase())>=0"><a-checkbox :checked="filters[column.id].indexOf(v)>=0" @change="(e)=>filterChange(column.id, v, e)">{{ v }}</a-checkbox></p>
                          </div>
                        </template>
                        <template slot="title">
                          <span><a-checkbox  @change="(e)=>filterChangeAll(column.id, e)" :checked="filters[column.id].length===filterOptions[column.id].length" :indeterminate="filters[column.id].length>0 && filters[column.id].length<filterOptions[column.id].length">全选</a-checkbox></span>
                        </template>
                        <span :class="`filter-icon ${filters[column.id].length!==filterOptions[column.id].length?'active':''}`" @click="(e)=>{e.stopPropagation();}"><a-icon type="filter" theme="filled" /></span>
                      </a-popover>
                    </div>
                  </th>
                </template>
                <th :colspan="columns.filter(c=>c.inner).length" :style="{'backgroundColor': expandInfo.color.innerHeader}">内部测试</th>
                <th :colspan="columns.filter(c=>c.lab).length" :style="{'backgroundColor': expandInfo.color.labHeader}">实验室测试</th>
              </tr>
              <tr class="custom-ugc-gameplay-table-tr">
                <template v-for="column in columns">
                  <th :key="column.id" v-if="(!column.pdLimit || !isPd) && (column.inner || column.lab)" :style="{'width': column.width, 'backgroundColor': column.headerColor, 'textDecoration': column.expandable?'underline':'none'}" :class="column.sorter?'sortable':''">
                    <div @click="onChangeSorter(column.id)">
                      <span>{{column.title}}</span>
                      <span :class="`sorter-icon ${sorter.id===column.id?`sorter-${sorter.order}`:''}`" v-if="column.sorter">
                        <a-icon type="caret-up" />
                        <a-icon type="caret-down" />
                      </span>
                    </div>
                  </th>
                </template>
              </tr>
            </thead>
          </table>
          <table class="custom-ugc-gameplay-table" id="ux-ugc-table-tbody">
            <tbody>
              <template v-for="record in filterDatas">
                <tr :key="record.name" class="custom-ugc-gameplay-table-tr">
                  <td v-for="column in columns" :key="`${record.name}_${column.id}`" v-if="(!column.pdLimit || !isPd)" :style="{'width': column.width, 'backgroundColor': column.bodyColor}">
                    
                    <div v-if="column.render==='dt'" :style="styleRender(column, record)">
                      <span :style="strongDate(column.value(record), record.inner?record.inner.dt:undefined, record.lab?record.lab.dt:undefined)?'font-weight: bold':''">{{ column.value(record) || '-'}}</span></div>
                    <!-- 视频 -->
                    <div v-if="column.render==='video'" :title="record.video?'点击查看录屏':null">
                      <span :class="record.video?'link':null" @click="record.video?modal = {show: true, path: record.video, title: record.name}:null">{{ record[column.id] }}</span>
                    </div>
                    <div v-if="column.render==='trend'" 
                      :style="styleRender(column, record)?{...styleRender(column, record), cursor: 'default'}:{ cursor: 'pointer'}"
                      @click="onExpand(record.name, column.id)"
                    >
                      <div style="width:150px; height: 80px; margin:0 auto;">
                        <trendChart :id="`${record.name}_${column.inner?'inner':'lab'}`" :data="record[column.id]" v-if="record[column.id] && record[column.id].length>0"/>
                        <div v-else style="line-height:80px">-</div>
                      </div>
                    </div>
                    <div v-if="column.render==='score'" 
                      :style="styleRender(column, record)?styleRender(column, record):{background:record[column.inner?'inner':'lab'] && record[column.inner?'inner':'lab'].score < 1?expandInfo.color.low: null}">
                      {{ column.formatter?column.formatter(column.value?column.value(record):record[column.id]):column.value?column.value(record):record[column.id] }}
                    </div>
                    <div v-if="column.render==='issue'" 
                      @click="onExpand(record.name, column.id)"
                      :style="styleRender(column, record)"
                      >
                      <span :class="((record[column.id] && record[column.id].length > 0) || record[`${column.id}_num`] > 0)?'clickable':''">
                        {{ ((record[column.id] && record[column.id].length > 0) || record[`${column.id}_num`] > 0) ? record[column.id] ? record[column.id].length : 0 : null | nilFormat}}</span>
                    </div>
                    <div v-if="column.render==='feedback'" 
                      @click="onExpand(record.name, column.id)" 
                      :style="styleRender(column, record)">
                      <span class="clickable" v-if="record[`${column.id}_num`]">
                        查看
                      </span>
                      <span v-else>
                        -
                      </span>
                    </div>
                    <div v-if="column.render==='stage'">
                      {{ record.stage === 6?'暂停':stageNames[record.stage] }}
                    </div>
                    <div v-if="!column.render" :style="styleRender(column, record)">
                      {{ column.formatter?column.formatter(column.value?column.value(record):record[column.id]):(column.value?column.value(record):record[column.id]) || '-'}}</div>
                  </td>
                </tr>
                <tr :key="`${record.name}_expand`" v-if="expand.id===record.name && expand.type">
                  <td :colSpan="columns.length">
                    <div class="detail_box">
                      <div class="detail_box_expand_btn" @click="onExpand(record.name, false)">
                        <a-icon type="up" />收起
                      </div>
                      <h3 :class="`${expand.type.startsWith('inner')?'inner':expand.type.startsWith('lab')?'lab':'common'}_h3`">
                        {{expandInfo.title[expand.type]}}
                      </h3>
                      <a-table v-if="expand.type!=='inner_issue' && expand.type!=='lab_issue'" rowKey="index" :pagination="false" size="middle" class="ugc-gameplay-table-children" :scroll="{y:500}" :loading="expandLoading"
                        :columns="expandInfo.columns[expand.type]" 
                        :dataSource="detailData[expand.type][record.name]?detailData[expand.type][record.name]:record[expand.type]"
                      >
                        <div slot="obstacle" slot-scope="text">
                          <span :class="`obstacle-span lv-${text}`">{{text || '-'}}</span>
                        </div>  
                        
                        <div slot="progress" slot-scope="text,record">
                          <span :class="`progress-span lv-${record.progressNum}`">{{text || '-'}}</span>
                        </div>

                        <div slot="feedbackOp" slot-scope="text,record2">
                          <template v-if="isUe">
                            <template v-if="!(editItem && editItem.id === record2.id)">
                              <a-button size="small" type="link" v-if="record2.id<10000000" @click="()=>{editItem={...record2}}">编辑</a-button>
                              <a-popconfirm title="确认删除该反馈吗" @confirm="deleteFeedback(record2, expand.type, record, detailData[expand.type][record.name])" v-if="record2.id<10000000">
                                <a-button size="small" type="link" style="color:#cc0000">删除</a-button>
                              </a-popconfirm>
                            </template>
                            <template v-else>
                              <a-button type="link" size="small" @click="saveFeedback(record2, expand.type, record, detailData[expand.type][record.name])">确定</a-button>
                              <a-button type="link" :style="{color: '#888'}" size="small" @click="()=>{editItem=undefined}">取消</a-button>
                            </template>
                          </template>
                        </div>
                        <template
                          v-for="col in ['f_version', 'f_score', 'f_art', 'f_fight', 'f_feedback']"
                          :slot="col"
                          slot-scope="text, record2"
                        >
                          <div :key="col">
                            <span v-if="!(editItem && editItem.id === record2.id)">{{text}}</span>
                            <a-textarea v-if="editItem && editItem.id === record2.id" v-model="editItem[col.split('_')[1]]" placeholder="请输入" size="small" rows="1" />
                          </div>
                        </template>
                      </a-table>
                      <IssueTable @update="updateIssueList" type="ugc" :meta="meta" :data="detailData[expand.type][record.name]?detailData[expand.type][record.name]:record[expand.type]" :progressOptions="progressOptions" v-else/>
                      <!-- 查看更多 -->
                      <div style="cursor: pointer; color: #1890FF; margin: 20px 0 0 0; font-size: 16px; text-align: center;"
                        v-if="['inner_feedback', 'lab_feedback', 'inner_issue', 'lab_issue'].indexOf(expand.type)>=0 
                        && !detailData[expand.type][record.name]
                        && ((record[expand.type] && record[`${expand.type}_num`]>record[expand.type].length) || (!record[expand.type] && record[`${expand.type}_num`]))" @click="()=>getDetailData(expand.type, record.name)">
                        查看更多
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <a-modal :title="modal.title" :width="800" :visible="modal.show" :maskClosable="true" @cancel="modal={show:false, path: undefined, title: undefined}">
      <video :src="`${modal.path}?token=viewBCVideoL28.R.eT3DKv3ho6opGQQ5SHDK4VH4`" controls="controls" style="width:100%">
        您的浏览器不支持 video 标签。
      </video>
      <template slot="footer">
        <a-button @click="modal={show:false, path: undefined, title: undefined}" type="default">关闭</a-button>
      </template>
    </a-modal>    
  </div>
</template>

<script>

import { isNil } from 'lodash';
import Vue from 'vue'
import moment from 'moment'
import ue from "./ue.vue";
import trendChart from "./trendChart.vue";
import IssueTable from "./issueTable.vue";
import { Checkbox, Popconfirm, Input } from 'ant-design-vue';
Vue.use(Checkbox)
Vue.use(Popconfirm)
Vue.use(Input)

const ColorMap = {
  low: 'rgba(205, 205, 205,0.5)',
  none: 'rgba(150, 150, 150, 0.5)',
  innerHeader: '#ffcc81', 
  innerBody: 'rgba(255, 248, 237, 0.5)',
  labHeader: '#d2e6bc', 
  labBody: 'rgba(244, 254, 231, 0.5)'
}

const PeriodMap = {
  '内部测试': 1,
  '实验室测试': 2,
  '对外': 3,
  '终止': 4
}

const ProgressMap = {
  '方案制定&决策中': 1,
  '待排期': 2,
  '进行中': 3,
  '已完成': 4,
  '需求冻结': 5,
  '不处理': 6,
  '待回复': 7,
}

const sorterFnc = (p, n)=> {
  return p==n?0:n==null?1:p==null?-1:typeof(p)==='number'?p-n:p.localeCompare(n)
}

const formatFnc = (v)=>{
  if(v!=null) {
    if(v%1===0) {
      return v
    }
    else {
      return v.toFixed(1)
    }
  }
  return '-'
}
const score_columns = [
  {id: 'scores', title:'趋势', width: '10%', dataIndex: false, inner: true, lab: true, render: 'trend', expandable: true},
  {id: 'score', title:'尖叫度', width: '4%', inner: true, lab: true, sorter: true, render: 'score', formatter:formatFnc},
  {id: 'art', title:'美术', width: '4%', lab: true, sorter: true, render: 'score',formatter:formatFnc},
  {id: 'fight', title:'操作', width: '4%', lab: true, sorter: true, render: 'score',formatter:formatFnc},
  {id: 'dt', title:'测试日期', width: '6%', inner: true, lab: true, sorter: true, render: 'dt'},
  {id: 'version', title:'测试版本', width: '5%', inner: true, lab: true, sorter: true},
  {id: 'cnt', title:'样本量', width: '4%', inner: true, lab: true, sorter: true},
  {id: 'issue', title:'剩余问题数', width: '4.5%', inner: true, lab: true, sorter: true, render: 'issue', expandable: true},
  {id: 'feedback', title:'反馈', width: '3%', inner: true, lab: true, render: 'feedback', expandable: true},
]
const columns = [
  {id: 'name', title:'玩法', width: '7%', sorter: true, render: 'video', expandable: true, filter: true},
  {id: 'pd', title:'负责人', width: '6%', sorter: true, filter: true},
  {id: 'stage', title:'所处阶段', width: '5.5%', sorter: (a, b) => ((b.stage === 4 ? 5.5 : b.stage === 6 ? -1 : b.stage === 7 ? -2 : b.stage) - (a.stage === 4 ? 5.5 :a.stage === 6 ? -1 : a.stage === 7 ? -2 : a.stage)), render:'stage'},
]

const types = ['inner', 'lab']
types.forEach(t=>{
  score_columns.forEach(c=>{
    if(c[t]) {
      const _c = {...c, value: c.dataIndex!=false?(record)=>record[t]?record[t][c.id]:null: false, id:`${t}_${c.id}`, headerColor: ColorMap[`${t}Header`], bodyColor: ColorMap[`${t}Body`],}
      _c[t==='inner'?'lab':'inner'] = false
      columns.push(_c)
      if(c.sorter) {
        if(c.id === 'issue') {
          _c.sorter = (a, b)=>sorterFnc(a[`${t}_issue`]?a[`${t}_issue`].length:0, b[`${t}_issue`]?b[`${t}_issue`].length:0)
        }
        else {
          _c.sorter = c.dataIndex!=false?(a, b)=>sorterFnc(a[t]?a[t][c.id]:undefined, b[t]?b[t][c.id]:undefined):(a, b)=>sorterFnc(a[c.id], b[c.id])
        }
      }
    }
  })
})
const expandIssueColumns = [
  { title: '阻碍等级', dataIndex: 'obstacle', width: 90, scopedSlots: { customRender: 'obstacle' }, },
  { title: '问题描述', dataIndex: 'description', scopedSlots: { customRender: 'remark' }, width: '50%', sorter: false },
  { title: '反馈频次', dataIndex: 'frequency', width: 90},
  { title: '对应功能解决', dataIndex: 'solution', sorter:false, customRender:(value)=>value?value:'-', customCell:(record)=>({style:{background: record.progress==='待回复'?ColorMap.none:null}}), width: '20%' },
  { title: '当前进度', dataIndex: 'progress', width: 92, scopedSlots: { customRender: 'progress' }, sorter: (a, b) => sorter(ProgressMap[a.progress], ProgressMap[b.progress]) },
  { title: '反馈周期', dataIndex: 'format_dt', width: 90},
  { title: '版本', dataIndex: 'version', width: 90},
]

const expandFeedbackColumns = [
  { title: '测试日期', dataIndex: 'dt', width: 100},
  { title: '测试版本', dataIndex: 'version', width: 100, scopedSlots: { customRender: 'f_version' }},
  { title: '测试类型', dataIndex: 'type', width: 100, customRender: (value)=>value===1?'内部测试':'实验室测试'},
  { title: '尖叫度', dataIndex: 'score', width: 90, scopedSlots: { customRender: 'f_score' }, customCell: (record)=>({style:{background:record.score<1?ColorMap.low:''}})},
  { title: '美术', dataIndex: 'art', width: 90, scopedSlots: { customRender: 'f_art' }},
  { title: '操作', dataIndex: 'fight', width: 90, scopedSlots: { customRender: 'f_fight' } },
  { title: '反馈', dataIndex: 'feedback', scopedSlots: { customRender: 'f_feedback' }},
  { title: '', dataIndex: 'op', width: 100, scopedSlots: { customRender: 'feedbackOp' }, sorter: false},
]
const innerExpandFeedbackColumns = [...expandFeedbackColumns]
innerExpandFeedbackColumns.splice(6, 0, {title:'操作模式', width: 100,  dataIndex: 'platform', customRender:(text)=>text===0?'手机':text===1?'手柄':text===2?'键鼠默认':text===3?'键鼠专家':''})

const expandInfo = {
  title: {
    'inner_scores': '内部测试版本分数详情',
    'lab_scores': '实验室测试版本分数详情',
    'inner_issue': '内部测试问题清单',
    'lab_issue': '实验室测试问题清单',
    'inner_feedback': '内部测试玩家反馈',
    'lab_feedback': '外部测试玩家反馈'
  },
  columns: {
    'inner_scores':[
      { title: '测试日期', dataIndex: 'dt', width: 100},
      { title: '测试版本', dataIndex: 'version',width: 100},
      { title: '尖叫度', dataIndex: 'score',width: 90, customRender: formatFnc, customCell: (record)=>({style:{background:record.score<1?ColorMap.low:''}})},
      { title:'操作模式', width: 100,  dataIndex: 'platform', customRender:(text)=>text===0?'手机':text===1?'手柄':text===2?'键鼠默认':text===3?'键鼠专家':''},
      { title: '样本量', dataIndex: 'cnt', width: 90},
    ],
    'lab_scores': [
      { title: '测试日期', dataIndex: 'dt', width: 100 },
      { title: '测试版本', dataIndex: 'version',width: 100},
      { title: '尖叫度', dataIndex: 'score', width: 90, customRender: formatFnc,  customCell: (record)=>({style:{background:record.score<1?ColorMap.low:''}})},
      { title: '美术', dataIndex: 'art', width: 90, customRender: formatFnc,},
      { title: '操作', dataIndex: 'fight', width: 90, customRender: formatFnc,},
      { title: '样本量', dataIndex: 'cnt', width: 90},
    ],
    'inner_feedback': innerExpandFeedbackColumns,
    'lab_feedback': [...expandFeedbackColumns],
    'inner_issue': [...expandIssueColumns],
    'lab_issue': [...expandIssueColumns],
  },
  color: ColorMap
}

Object.keys(expandInfo.columns).forEach(key=>{
  expandInfo.columns[key].forEach(c=>{
    if(c.sorter!==false && !c.sorter) {
      c.sorter = (a, b)=>sorterFnc(a[c.dataIndex], b[c.dataIndex])
    }
  })
})

export default {
  name: 'UxUGCPanel',
  props: {
    api: {
      type: String,
    },
    title: {
      type: String,
      default: 'UGC玩法'
    }
  },  
  components: {
    ue, trendChart, IssueTable
  },
  filters:{
		nilFormat: function(value){
      return value!=null?value:'-'
		}
	},
  data() {
    return {
      editItem: undefined,
      ues: {
        pd: [{name: '曾国芬', email: 'hzzengguofen@corp.netease.com'}],
        content: [{name: '张锦雯', email: 'wf.zhangjinwen@corp.netease.com'}, {name: '官伟聪', email: 'koonweichung@corp.netease.com'}]
      },
      stageNames:['策划组初步开发','处于内部测试环节','处于外部测试环节','外测分数达标(>1分)','日常测试包','判定为UGC玩法','暂停','其他'],
      loading: false,
      datas: [],
      filterOptions: {
        name: [], 
        pd: [],
      },
      filters: {
        name: [],
        pd: [],
      },
      stageFilter: undefined,
      filterOptionFilters: {
        name: undefined,
        pd: undefined,
      },
      sortedDatas: [],
      columns,
      sorter: {id: 'stage', order: 'asc'},
      expand: {id: undefined, type: undefined},
      expandInfo,
      expandLoading: false,
      modal: {
        show: false,
        path: undefined,
        title: undefined
      },
      reload: false,
      // 存展开详情
      detailData: {
        inner_feedback: {},
        lab_feedback: {},
        inner_scores: {},
        lab_scores: {},
        inner_issue: {},
        lab_issue: {},
      },
      meta: {
        obstacle: [],
        progress: [],
        sum: { real_sum: 0, pause_sum: 0 }
      },
      stages: [],
    }
  },
  mounted() {
    this.getData();

    const width = document.getElementById('ux-ugc-table-tbody').getBoundingClientRect().width
    const top = document.getElementById('ux-ugc-table').getBoundingClientRect().top
    if(top<=0 && width>0) {
      document.getElementById('ux-ugc-table-thead').setAttribute('style', `position: fixed; top:0; width: ${width}px`);
    }
    else {
      document.getElementById('ux-ugc-table-thead').removeAttribute('style');
    }
    
    window.addEventListener('scroll', function() {
      const width = document.getElementById('ux-ugc-table-tbody').getBoundingClientRect().width
      const top = document.getElementById('ux-ugc-table').getBoundingClientRect().top
      if(top<=0 && width>0) {
        document.getElementById('ux-ugc-table-thead').setAttribute('style', `position: fixed; top:0; width: ${width}px`);
      }
      else {
        document.getElementById('ux-ugc-table-thead').removeAttribute('style');
      }
    });
  },
  computed: {
    filterDatas() {
      return this.sortedDatas.filter((row)=>{
        let flag = true
        if(this.filters.name.length > 0) {
          if(this.filters.name.indexOf(row.name) < 0) {
            flag = false
          }
        }
        if(this.filters.pd.length > 0) {
          if(this.filters.pd.indexOf(row.pd) < 0) {
            flag = false
          }
        }
        return flag
      }).filter(row => this.stageFilter === undefined || this.stageFilter === row.stage)
    },
    progressOptions() {
      const [progressArr] = this.getOptWithMap(this.meta.progress);
      return progressArr;
    },
    isPd() {
      const pds = this.filterOptions.pd
      const name = this.$store.state.user.name
      if(this.$store.state.user && pds.indexOf(name)>=0 && name!='许泽臣' && name!='刘勇成') {
        return true
      }
      return false
    },
    isUe() {
      const ls = ['hzchenchen7@corp.netease.com', 'wf.zhanghaoyu@corp.netease.com', 'koonweichung@corp.netease.com', 'hzliuying1@corp.netease.com', 'hzzengguofen@corp.netease.com', 'liuming04@corp.netease.com', 'hzhujiasheng@corp.netease.com', 'chua_xin_rou@corp.netease.com', 'yingyixin@corp.netease.com']
      if(this.$store.state.user) {
        const email = this.$store.state.user.email
        if(ls.indexOf(email)>=0) {
          return true
        }
      }
      return false
    },
    summary() {
      const ret = {}
      for (let i = 0; i < 8; i++){
        ret[i] = 0;
      }
      this.stages.forEach(stage=>{
        ret[stage.stage || 0] += 1
      })
      return ret
    },
    // sortedDatas() {
    //   // 内部测->实验室测->对外->终止
    //   const self = this
    //   const _datas = this.datas.map(row=>{if(row.inner){row.inner.type='inner'} if(row.lab){row.lab.type='lab'} return row}).sort((p, n)=>{
    //     const pp = PeriodMap[p.period] || 999
    //     const np = PeriodMap[n.period] || 999
    //     const pl = p.lab?.score || -999
    //     const nl = n.lab?.score || -999
    //     const pi = p.inner?.score || -999
    //     const ni = n.inner?.score || -999
    //     return pp!==np?pp>np?1:-1:pl!==nl?pl>nl?-1:1:pi!==ni?pi>ni?-1:1:0
    //   })
    //   console.log(this.sorter, 'sorter')
    //   let res = _datas
    //   if(this.sorter.id) {
    //     const c = columns.find(c=>c.id===this.sorter.id)
    //     if(c && c.sorter) {
    //       if(c.sorter === true) {
    //         console.log(1)
    //         res = _datas.sort((a, b)=>sorter(a[c.id], b[c.id]))
    //       }
    //       else {
    //         console.log(2)
    //         res = _datas.sort(c.sorter)
    //       }
    //       if(this.sorter.order === 'desc') {
    //         console.log(3)
    //         res = res.reverse()
    //       }
    //     }
    //   }
      
    //   this.reload = true
    //   this.$nextTick(()=>{
    //     this.reload = false
    //   })
    //   return res
    // },
  },
  methods: {
    strongDate(value, inner, lab) {
      return moment(value).isAfter(moment().startOf('week').subtract(1, 'second'))
    },
    getOptWithMap(list) {
      const tmpArr = [];
      const tmpMap = {};
      (list || []).forEach(l => {
        tmpArr.push({ id: l.value, label: l.value });
        tmpMap[l.value] = l;
      });
      return [tmpArr, tmpMap];
    },
    filterChange(column, value, e) {
      const _filters = {...this.filters}
      const index = this.filters[column].indexOf(value)
      if(e.target.checked && index<0) {
        _filters[column] = [...this.filters[column], value]
        this.filters = _filters
      }
      if(!e.target.checked && index>=0) {
        const _filterItems = [...this.filters[column]]
        _filterItems.splice(index, 1)
        _filters[column] = _filterItems
        this.filters = _filters
      }
    },
    filterChangeAll(column, e) {
      const _filters = {...this.filters}
      if(e.target.checked) {
        _filters[column] = [...this.filterOptions[column]]
      }
      else {
        _filters[column] = []
      }
      this.filters = _filters
    },
    styleRender(column, record) {
      return column.lab && record.period === '内部测试'?{background: expandInfo.color.none}:null
    },
    onChangeSorter(id) {
      let sorter = this.sorter
      if(this.sorter.id === id) {
        if(this.sorter.order === 'desc') {
          sorter = {id: undefined, order: undefined}
        }
        else {
          sorter = {id, order: 'desc'}
        }
      } 
      else {
        sorter = {id, order: 'asc'}
      }
      this.sorter = sorter
      this.sortData(this.datas, sorter)
    },
    onStageFilter(id) {
      if (this.stageFilter === id) {
        this.stageFilter = undefined;
      } else {
        this.stageFilter = id;
      }
      // const index = this.stageFilter.findIndex(x => x === id)
      // if (index > -1) {
      //   this.stageFilter.splice(index, 1)
      // } else {
      //   this.stageFilter.push(id)
      // }
    },
    clearStageFilter() { 
      this.stageFilter = undefined;
    },
    onExpand(id, type) {
      // const _expand = {...this.expand}
      if(type === false) {
        this.expand={id: undefined, type: undefined}
      }
      else {
        if(id === this.expand.id) {
          if(this.expand.type === type) {
            this.expand={id: undefined, type: undefined}
          }
          else {
            this.expand={id, type}
          }
        }
        else {
          this.expand={id, type}
        }
      }
      
      this.reload = true
      this.$nextTick(()=>{
        this.reload = false
      })
    },
    getData() {
      this.loading = true;
       this.$service.query_fixed_module(this.api).then(res => {
         this.loading = false;
         if (res.data) {
          const datas = res.data?res.data.data:[] || []
          this.meta = res.data?res.data.meta:{}
          this.stages = res.data ? res.data.stages : []
          this.datas = datas;

          const stagesDict = {}
          this.stages.forEach(x => {
            stagesDict[x.gameplay] = x.stage || 0
          })
          const _gameplays_dict = {}
          const _gameplays = []
          const _pds_dict = {}
          const _pds = []
           datas.forEach(row => {
            row.stage = stagesDict[row.name] || 0
            if(!_gameplays_dict[row.name]) {
              _gameplays.push(row.name)
              _gameplays_dict[row.name] = true
            }
            if(!_pds_dict[row.pd]) {
              _pds.push(row.pd)
              _pds_dict[row.pd] = true
            }
          })
          this.filterOptions={name: _gameplays, pd: _pds}
          this.filters = { name: [..._gameplays], pd: [..._pds] }
          this.sortData(datas, this.sorter)
         }
       }).catch(() => {
         this.loading = false;
       });
    },
    getDetailData(type, gameplay) {
      this.expandLoading = true;
       this.$service.query_fixed_module(this.api, {type, gameplay}).then(res => {
         this.expandLoading = false;
         if (res.data) {
            const _obj = {...this.detailData[type]}
           _obj[gameplay] = res.data || [];
           if((type === 'inner_issue' || type === 'lab_issue') && _obj[gameplay]) {
            _obj[gameplay] = _obj[gameplay].sort((a, b)=>{
              if(a.version!=b.version) {
                return a.version>b.version?-1:1
              }
              if(a.obstacle!=b.obstacle) {
                return a.obstacle - b.obstacle
              }
              if(a.progress!=b.progress) {
                return ProgressMap[a.progress] - ProgressMap[b.progress]
              }
              if(a.frequency!=b.frequency) {
                return -a.frequency + b.frequency
              }
              return a.issue_id > b.issue_id?1:-1
            })
           }
           this.detailData[type] = _obj
         }
       }).catch(() => {
         this.expandLoading = false;
       });
    },
    updateIssueList(issueList) {
      // 如果有更多数据
      if(this.detailData[this.expand.type][this.expand.id]) {
        const _detailData = {...this.detailData}
        _detailData[this.expand.type] = {..._detailData[this.expand.type]}
        _detailData[this.expand.type][this.expand.id] = issueList
        this.detailData = _detailData
      }
      else {
        const index = this.datas.findIndex(row=>row.name==this.expand.id)
        const sindex = this.sortedDatas.findIndex(row=>row.name==this.expand.id)
        if(index >= 0) {
          const _datas = [...this.datas]
          const _sortedData = [...this.sortedDatas]
          const _dataItem = {..._datas[index]}
          _dataItem[this.expand.type] = issueList
          _datas.splice(index, 1, _dataItem)
          _sortedData.splice(sindex, 1, _dataItem)
          this.datas = _datas
          this.sortedDatas = _sortedData
        }
      }
    },
    sortData(datas, sorter) {
      // 内部测->实验室测->对外->终止
      // const self = this
      const _datas = datas.map(row=>{if(row.inner){row.inner.type='inner'} if(row.lab){row.lab.type='lab'} return row}).sort((p, n)=>{
        // const pp = PeriodMap[p.period]
        // const np = PeriodMap[n.period]
        // const pl = p.lab?.score
        // const nl = n.lab?.score
        // const pi = p.inner?.score
        // const ni = n.inner?.score
        const p1 = sorterFnc(PeriodMap[p.period], PeriodMap[n.period])
        if(p1!=0) {
          return -p1
        }
        const p2 = sorterFnc(p.lab?.score, n.lab?.score)
        if(p2!=0) {
          return -p2
        }
        return -sorterFnc(p.inner?.score, n.inner?.score)
      })
      let res = _datas
      if(sorter.id) {
        const c = columns.find(c=>c.id===sorter.id)
        if(c && c.sorter) {
          if(c.sorter === true) {
            res = _datas.sort((a, b)=>sorterFnc(a[c.id], b[c.id]))
          }
          else {
            res = _datas.sort((a, b)=>c.sorter(a, b))
          }
          if(sorter.order === 'desc') {
            res = res.reverse()
          }
        }
      }
      
      this.sortedDatas = res
      this.reload = true
      this.$nextTick(()=>{
        this.reload = false
      })
    },
    deleteFeedback(item, type, record, detail) {
      this.$service.query_fixed_module(this.api, {type:'delete_feedback', id: item.id,}).then((d) => {
        this.$message.success(`删除成功`);
        const _pi = record[type].findIndex(d=>d.id===item.id)
        if(_pi >= 0) {
          record[type].splice(_pi, 1)
          record[`${type}_num`] -= 1
        }
        if(detail) {
          const _i = detail.findIndex(d=>d.id===item.id)
          if(_i>=0) {
            detail.splice(_i, 1)
          }
        }
        
      }).catch(err => {
        console.log(err)
        this.$message.error(`删除失败`);
      })
    },
    saveFeedback(item, type, record, detail) {
      const editItem = this.editItem
      let params = {
        id: editItem.id,
        version: isNil(editItem.version) ? '' : editItem.version,
        score: isNil(editItem.score) ? '' : editItem.score,
        art: isNil(editItem.art) ? '' : editItem.art,
        fight: isNil(editItem.fight) ? '' : editItem.fight,
        feedback: isNil(editItem.feedback) ? '' : editItem.feedback,
      }
      console.log(params)
      if(!/^-?\d+$/.test(params.score) || !/^-?\d+$/.test(params.art) || !/^-?\d+$/.test(params.fight)) {
        this.$message.error('分数必须为整数')
        return
      }

      if(!params.version || params.version.trim()==='') {
        this.$message.error('版本号必填')
        return
      }
      
      this.$service.query_fixed_module(this.api, {...params, type:'edit_feedback'}).then(d => {
        this.$message.success(`更新反馈 ${editItem.id} 成功`);
        this.editItem = undefined;
        const _pi = record[type].findIndex(d=>d.id===editItem.id)
        if(_pi >= 0) {
          record[type].splice(_pi, 1, d.data)
        }
        if(detail) {
          const _i = detail.findIndex(d=>d.id===editItem.id)
          if(_i>=0) {
            detail.splice(_i, 1, d.data)
          }
        }
      }).catch(err => {
        console.log(err)
        this.$message.error(`更新反馈 ${this.editItem.id} 失败`);
      })
    },
  }
}
</script>

<style lang="less" scoped>
.ux-ugc-wrap {
  .ugc-panel {
    padding-bottom: 20px;
    &.data-panel {
      margin-top: 0;
    }
    .ux-filter-title {
      display: inline-block;
      text-align: right;
      width: 64px;
      margin: 0 12px;
      font-weight: bold;
    }
    .data-panel-content {
      padding-top: 12px;
    }
  }
  
  .filter-wrap {
    display: flex;
    flex-wrap: wrap;
    
  }
  .filter {
    padding-bottom: 12px;
  }
}

span.sorter-icon {
  display: inline-block;
  width: 12px;
  .ant-icon {
    font-size: 12px;
  }
}
</style>


<style lang="less">
.ugc-gameplay-table {
  
  .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,
  .ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,
  .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
    padding: 5px 0;
  }
  .ant-table-thead > tr > th .ant-table-column-sorters .ant-table-column-sorter {
    margin: 0;
  }
  .trend_detail_box {
    background: #fff;
    padding: 30px 50px;
    h3 {
      text-align: left;
      border-left:3px solid #000;
      padding: 0 0 0 30px;
      line-height: 20px;
      &.inner_h3, &.inner_issue_h3{
        border-color: #ffcc81
      }
      &.lab_h3, &.lab_issue_h3{
        border-color: #d2e6bc;
      }
      &.feedback_h3{
        border-color: #1890ff;
      }
    }
    .ugc-gameplay-table-children {
      
      .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th, .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
        padding: 5px;
      }
    }
  }
}
.ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row), .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row), .ant-table-thead > tr:hover:not(.ant-table-expanded-row), .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) {
  background: #e6f7ff;
}

.obstacle-span {
    display: inline-block;
    width: 24px;
    line-height: 24px;
    border-radius: 50%;
    background-color: #c4c4c4;
    &.lv-1 {
      background-color: #f14949;
    }
    &.lv-2 {
      background-color: #ffc60a;
    }
    &.lv-3 {
      background-color: #fdddcd;
    }
    &.lv-4 {
      background-color: #c4c4c4;
    }
  }


.custom-ugc-gameplay-table {
  z-index: 999999;
  width: 100%;
  &:nth-child(2) {
    margin: -1px 0 0 0;
    z-index: 999998;
  }
  tr.custom-ugc-gameplay-table-tr {
    th, td {
      text-align: center;
      border: 1px solid #ddd;
      vertical-align: middle;
    }
    th {
      height: 30px;
      vertical-align: middle;
      background: #fafafa;
      &.sortable {
        cursor: pointer;
      }
      div {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
      span.filter-icon {
        position: absolute;
        right: 0px;
        padding: 0 5px;
        display: flex;
        align-items: center;

        height: 100%;
        cursor: pointer;
        .anticon {
          font-size: 12px;
          color: #aaa;
        }
        &:hover {
          background: #ddd;
        }
        &.active {
          .anticon {
            color: #1890ff;
          }
        }
      }
      span.sorter-icon {
        display: inline-block;
        width: 12px;
        height: 16px;
        position: relative;
        margin: 0 0 0 5px;
        cursor: pointer;
        &.sorter-asc {
          .anticon:nth-child(1) {
            color: #1890ff;
          }
        }
        &.sorter-desc {
          .anticon:nth-child(2) {
            color: #1890ff;
          }
        }
        .anticon {
          position: absolute;
          top: 0;
          left: 0;
          font-size: 10px;
          color: #6b6b6b;
          &:nth-child(2) {
            top: 7px;
          }
        }
      }
    }
    td {
      height: 80px;
      > div {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .link {
        cursor: pointer;
        text-decoration: underline;
        color: #1890ff;
      }
      .clickable {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
  
  .detail_box {
    position: relative;
    background: #fff;
    padding: 30px 60px;
    .detail_box_expand_btn {
      position: absolute;
      left: 0;
      color: #535353;
      border: 1px solid #ddd;
      background: #ededed;
      font-size: 12px;
      padding: 0 5px;
      cursor: pointer;
      span.anticon {
        font-size: 10px;
      }
    }
    h3 {
      text-align: left;
      border-left:3px solid #000;
      padding: 0 0 0 20px;
      line-height: 20px;
      margin: 0 0 20px 0;
      &.inner_h3{
        border-color: #ffcc81
      }
      &.lab_h3{
        border-color: #d2e6bc;
      }
      &.feedback_h3{
        border-color: #1890ff;
      }
    }
    .ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,
    .ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td {
      padding: 5px;
    }
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th, .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
      padding: 5px;
    }
  }
}


.ugc-table-filter-container {
  .ant-popover-inner-content {
    padding: 0;
  }
  .ugc-table-filter-box {
    height: 300px;
    overflow-y: auto;
    padding: 10px 16px;
    &::-webkit-scrollbar {
      width: 5px; /*滚动条宽度*/
      height: 5px; /*滚动条高度*/
      background: #f1f1f1;
    }

    /*定义滑块 内阴影+圆角*/
    &::-webkit-scrollbar-thumb {
      border-radius: 3px; /*滚动条的圆角*/
      background-color: #bbb; /*滚动条的背景颜色*/
    }
  }
}

.ugc-data-panel-stat-box {
  display: flex;
  .ugc-data-panel-stat {
    background: #d6d6d6;
    margin: 0 10px 0 0;
    h3 {
      font-size: 16px;
      text-align:center;
      padding: 5px 0;
      margin: 0;
      font-weight: bold;
        line-height: 24px;
    }
    .ugc-data-panel-stat-inner {
      display: flex;
      height: 50px;
      background:#efefef;
      
    }
    .ugc-data-panel-stat-item {
      width: 130px;
      border:3px solid #fff0;
      &-filter {
        cursor:pointer;
        user-select: none;
        label {
          cursor:pointer;
        }
      }
      &-selected {
        border-radius: 4px;
        box-sizing: border-box;
        border:3px solid #80d624;
      }
      label, span {
        display: block;
        text-align: center;
        font-size: 13px;
        font-weight: normal;
        line-height: 22px;
      }
      span {
        font-size: 15px;
        font-weight: bold;
      }
      &.ugc-data-panel-stat-single-item span{
        // line-height: 48px;
        // font-size: 20px;
      }
    }
    &.lab {
      background: #d2e6bc;
      .ugc-data-panel-stat-inner {
        background:#e3f2d2;
      }
    }
    &.inner {
      background: #ffcc81;
      .ugc-data-panel-stat-inner {
        background: rgba(255, 248, 237, 0.5);
      }

    }
  }
  .ugc-data-panel-stat.lab {
    position: relative;
    z-index: 1;
    .ugc-data-panel-stat-clear {
      transition: all 0.3s ease;
      z-index: -1;
      position: absolute;
      right: -24px;
      bottom: 0;
      font-size: 24px;
      background-color: #e3f2d2;
      border: 1px solid #e3f2d2;
      border-radius: 0 5px 5px 0;
      padding: 0 3px;
      cursor: pointer;
      &:hover {
        background-color: #d2e6bc;
        color:red;
      }
      &-hidden {
        right: 0;
      }
    }
  }
}
  
.ux-exp-tabs {
  padding-top: 20px;
  &.ant-tabs-card {
    .ant-tabs-content {
      margin-top: -16px;
      // .ant-tabs-tabpane {
      //   background: #fff;
      // }
    }
    .ant-tabs-bar {
      border-color: #fff;
      .ant-tabs-tab {
        border-color: transparent;
        background: transparent;
        font-size: 16px;
        font-weight: bold;
      }
      .ant-tabs-tab-active {
        border-color: #fff;
        background: #fff;
      }
    }
  }
}
</style>